import { useForm, Link } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export default function AdminOrganization({ organization, currentUser, errors: serverErrors, flash }) {
  const { data, setData, patch, processing, errors } = useForm({
    organization: { name: organization.name || '' },
  })
  const allErrors = { ...errors, ...serverErrors }

  function handleSubmit(e) {
    e.preventDefault()
    patch('/admin/organization')
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto flex items-center justify-between px-4 py-4">
          <h1 className="text-xl font-bold">Live Triage</h1>
          <div className="flex items-center gap-4">
            <Link href="/dashboard"><Button variant="ghost" size="sm">Dashboard</Button></Link>
            <Link href="/admin/agents"><Button variant="ghost" size="sm">Agents</Button></Link>
            <span className="text-sm text-muted-foreground">{currentUser?.email}</span>
            <Link href="/users/sign_out" method="delete" as="button">
              <Button variant="outline" size="sm">Sign out</Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto max-w-2xl px-4 py-10">
        <h2 className="text-2xl font-semibold tracking-tight">Organization settings</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Agent personas (prompt, avatar, intake fields) live under <Link href="/admin/agents" className="underline">Agents</Link>.
        </p>

        {flash?.notice && (
          <div className="mt-6 rounded-md border border-emerald-500/20 bg-emerald-500/10 px-3 py-2 text-sm text-emerald-700">
            {flash.notice}
          </div>
        )}

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Organization name</Label>
            <Input id="name" value={data.organization.name}
              onChange={(e) => setData('organization', { ...data.organization, name: e.target.value })} />
            {allErrors?.name && <p className="text-sm text-destructive">{allErrors.name.join(', ')}</p>}
            <p className="text-xs text-muted-foreground">URL slug: <span className="font-mono">{organization.slug}</span> (stable once created)</p>
          </div>
          <div className="flex justify-end">
            <Button type="submit" disabled={processing}>Save</Button>
          </div>
        </form>
      </main>
    </div>
  )
}
